export const ADDITIONAL = { page: 0 };
export const DEBOUNCE_TIMEOUT = 500;
export const PER_PAGE = 50;
